import { render } from "./Textbox.vue?vue&type=template&id=5b3bfefe&scoped=true&ts=true"
import script from "./Textbox.vue?vue&type=script&lang=ts"
export * from "./Textbox.vue?vue&type=script&lang=ts"

import "./Textbox.vue?vue&type=style&index=0&id=5b3bfefe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b3bfefe"]])

export default __exports__